/* eslint no-fallthrough: 0 */
import { combineReducers } from 'redux';
import { success, failure, initial, pending, RemoteData } from '@devexperts/remote-data-ts';
import ids, { ids as idsType } from './ids';
import total, { total as totalType } from './total';
import { ListAction } from '..';
import { getType } from 'typesafe-actions';
import * as listActions from 'sideEffect/crud/getList/actions';
import { crudDeleteSuccess } from 'sideEffect/crud/delete/actions';
import { ActionType } from 'typesafe-actions';

interface List {
    ids: idsType;
    total: totalType;
}
const listReducer = (resource: string) =>
    combineReducers<List>({
        ids: ids(resource),
        total: total(resource),
    });

export default (resource: string) => {
    const listRepresentationReducer = listReducer(resource);
    const reducer = (
        previousState: RemoteData<Error, List> = initial,
        action: ListAction | ActionType<typeof crudDeleteSuccess>,
    ): RemoteData<Error, List> => {
        switch (action.type) {
            case getType(listActions.crudGetList):
                if (!previousState.isSuccess()) {
                    return pending;
                }
            case getType(listActions.crudGetListSuccess):
                return success(
                    listRepresentationReducer(previousState.isSuccess() ? previousState.value : undefined, action),
                );
            case getType(crudDeleteSuccess):
                return previousState.map(prevState => listRepresentationReducer(prevState, action));
            case getType(listActions.crudGetListFailure):
                if (!previousState.isSuccess()) {
                    return failure(action.payload);
                }
            default:
                return previousState;
        }
    };
    return reducer;
};
